import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons";

const Panel = ({ children }) => (
  <div className="bg-white rounded-lg shadow-lg p-4 border-t-4 border-primary mb-4">
    <div>{children}</div>
  </div>
);

const MembersMyCase = () => (
  <>
    <div className="flex flex-row mt-4">
      <select className="py-3 rounded px-2 font-bold text-black outline-none shadow shadow-lg">
        <option>Tier 0</option>
        <option>Tier 1</option>
        <option>Tier 2</option>
      </select>
      <select className="py-3 rounded px-2 ml-4 font-bold text-black outline-none shadow shadow-lg">
        <option>Pending for Review(89)</option>
        <option>Pending for Decision(89)</option>
        <option>Escalated(23)</option>
        <option>Approved(8)</option>
      </select>
      <button type="button" className="ml-auto">
        <FontAwesomeIcon
          icon={faArrowAltCircleRight}
          size="2x"
          color="#30dfc4"
        />
      </button>
    </div>
    <div className="mt-4 flex flex-row">
      <div className="flex-1 mr-4">
        <Panel>
          <div className="flex flex-row items-center">
            <h4 className="mr-2 text-xl font-bold">User Profile</h4>
            <span className="px-2 py-1 bg-primary rounded-full text-white text-xs">
              Active
            </span>
          </div>
          <div className="mt-4">
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">User ID:</span>
              <span className="flex-1">61871ds8fn</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Nickname:</span>
              <span className="flex-1">66ffnfj</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Telephone:</span>
              <span className="flex-1">+448746748643</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Total Referral:</span>
              <span className="flex-1">8</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Referrer:</span>
              <span className="flex-1">77jhdsjf</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Tag:</span>
              <span className="flex-1">-</span>
            </div>
            <div className="mt-4 flex flex-row">
              <button
                type="button"
                className="w-24 py-1 rounded bg-primary text-white"
              >
                Log
              </button>
              <button
                type="button"
                className="ml-2 w-24 py-1 rounded border-2 border-primary text-primary"
              >
                Reassign
              </button>
              <button
                type="button"
                className="ml-auto px-2 py-1 rounded underline border-primary text-primary"
              >
                Activate
              </button>
              <button
                type="button"
                className="ml-2 px-2 py-1 rounded underline border-red-500 text-red-500"
              >
                Blacklist
              </button>
            </div>
          </div>
        </Panel>
        <Panel>
          <div className="flex flex-row items-center">
            <h4 className="mr-2 text-xl font-bold">Personal Information</h4>
            <span className="px-2 py-1 bg-blue-500 rounded-full text-white text-xs">
              Pending for decision
            </span>
          </div>
          <div className="mt-4">
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">First Name:</span>
              <span className="flex-1">YO TAI</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Middle Name:</span>
              <span className="flex-1">-</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Last Name:</span>
              <span className="flex-1">Ma</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">DOB</span>
              <span className="flex-1">17-06-1989</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Nationality:</span>
              <span className="flex-1">Chinese</span>
            </div>
            <div className="flex flex-row mt-2">
              <span className="w-48 font-bold">Place of Birth:</span>
              <span className="flex-1">Hong Kong</span>
            </div>
            <div className="mt-4 flex flex-row">
              <button
                type="button"
                className="w-24 px-2 py-1 rounded bg-primary text-white"
              >
                Approve
              </button>
              <button
                type="button"
                className="w-24 ml-2 px-2 py-1 rounded bg-red-500 text-white"
              >
                Reject
              </button>
              <button
                type="button"
                className="ml-auto px-2 py-1 rounded underline border-primary text-primary"
              >
                Escalate
              </button>
            </div>
          </div>
        </Panel>
      </div>
      <div className="w-1/3">
        <Panel title="Internal Note">
          <h4 className="text-xl font-bold">Internal Note</h4>
          <div className="mt-4">
            <form>
              <textarea
                className="w-full border border-2 border-gray-200 p-2 mb-2"
                rows={4}
                placeholder="note..."
              />
              <button
                type="button"
                className="inline-block w-24 py-1 rounded bg-primary text-white"
              >
                Submit
              </button>
            </form>
            <h5 className="mt-4 font-bold text-lg pt-4">History</h5>
            <ul>
              <li className="mt-3 border-1 border-b border-gray-300 pb-4">
                <div className="flex flex-row">
                  <span className="text-sm font-bold">Robert Yu</span>
                  <span className="text-sm text-gray-500 ml-auto">
                    30, August 2016
                  </span>
                </div>
                <p>Request to change nickname from robertyuuu to 66yoyoma.</p>
              </li>
              <li className="mt-3">
                <div className="flex flex-row">
                  <span className="text-sm font-bold">Robert Yu</span>
                  <span className="text-sm text-gray-500 ml-auto">
                    30, August 2016
                  </span>
                </div>
                <p>Request to change nickname from robertyuuu to 66yoyoma.</p>
              </li>
            </ul>
          </div>
        </Panel>
      </div>
    </div>
  </>
);

export default MembersMyCase;
